// extracted by mini-css-extract-plugin
export default {"details":"GalleryDetails_details__Ik7ex","deleteButton":"GalleryDetails_deleteButton__rF-cE"};